import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { DialogActions, NewSceneCancelError } from './DialogActions';
import { SaveType } from '../constants/Enums';
import { SceneActions } from './SceneActions';
import { SceneStore } from '../stores/SceneStore';
import { ProjectSettingsStore } from '../stores/ProjectSettingsStore';
import { CustomLoginUserInfo } from '../stores/CustomLoginStore';
import { getUserInfo, login } from '../utils/OpenID';
import { getUserInfo as getExternalUserInfo, login as externalLogin, logout as externalLogout } from '../utils/ExternalCustomerLogin';
import { parseQueryString } from '../submodules/utils/Url';
import { Dict } from '../submodules/utils/Types';

import utils = egr.wcf.utils;

export abstract class CustomLoginActions {
    public static async login(): Promise<void> {
        try {
            // first: save project / inform about data loss
            const saveType: SaveType = await DialogActions.newProject();
            const wasSaved: boolean = await SceneActions.saveScene(saveType);
            if (wasSaved !== true) {
                throw new NewSceneCancelError('Save action was cancelled');
            }
            await login();
            // await CustomLoginActions.backgroundLogin();

            // finally: open new scene
            // await SceneActions.newScene(null, SaveType.NOT);
        } catch (error) {
            if (!(error instanceof NewSceneCancelError)) {
                throw error;
            }
        }
    }

    public static async loginExternal(): Promise<void> {
        try {
            // first: save project / inform about data loss
            const saveType: SaveType = await DialogActions.newProject();
            const wasSaved: boolean = await SceneActions.saveScene(saveType);
            if (wasSaved !== true) {
                throw new NewSceneCancelError('Save action was cancelled');
            }

            await externalLogin();

            // finally: open new scene
            // await SceneActions.newScene(null, SaveType.NOT);
        } catch (error) {
            if (!(error instanceof NewSceneCancelError)) {
                throw error;
            }
        }
    }

    public static async logout(): Promise<void> {
        let saveType: SaveType | null = SaveType.NOT;
        if (SceneStore.getState().unsavedChanges) {
            const downloadPossible: boolean = (
                SceneStore.getState().elementCount > 0 || ProjectSettingsStore.getState().floorPlan != null
            );
            await DialogActions.newProject(!downloadPossible).then(
                (result: SaveType) => { saveType = result; }
            ).catch(
                () => { saveType = null; }
            );
        }
        if (saveType == null) {
            return;
        }
        if (saveType !== SaveType.NOT) {
            await SceneActions.closeScene(saveType);
        }

        AppDispatcher.dispatch({
            actionType: ActionConstants.CUSTOM_LOGIN_LOGOUT
        });

        const args: Dict = parseQueryString(window.location.hash.substr(1));

        if (!utils.string.isNullOrEmpty(args.originType) && args.originType === 'external') {
            externalLogout();
        }
        await SceneActions.newScene(null, SaveType.NOT);
    }

    public static async backgroundLogin(): Promise<void> {
        let userInfo: CustomLoginUserInfo | null;

        const args: Dict = parseQueryString(window.location.hash.substr(1));

        if (!utils.string.isNullOrEmpty(args.originType) && args.originType === 'external') {
            userInfo = await getExternalUserInfo<CustomLoginUserInfo>();
        } else {
            userInfo = await getUserInfo<CustomLoginUserInfo>();
        }
        // const userInfo: CustomLoginUserInfo | null = await getUserInfo<CustomLoginUserInfo>();
        // const userInfo: CustomLoginUserInfo | null = {
        //     nonce: '12345',
        //     sub: '5031SN9WU6',
        //     displayName: 'Petra Kromer',
        //     name: 'Petra Kromer',
        //     acr: 'urn:ibm:security:policy:id:1',
        //     iss: 'https://blancfischer.ice.ibmcloud.com/oidc/endpoint/default',
        //     preferred_username: 'DE00109723',
        //     uniqueSecurityName: '5031SN9WU6',
        //     at_hash: 'UiXiM0C1RGIPGQOjnaU-lw',
        //     userType: 'federated',
        //     realmName: 'blancfischer.ice.ibmcloud.com',
        //     ext: '{"tenantId":"blancfischer.ice.ibmcloud.com"}',
        //     exp: 1548339682,
        //     iat: 1548332482,
        //     aud: 'b81d2407-aafa-4afd-974f-68b2f6e5dbee'
        // };
        if (userInfo != null) {
            AppDispatcher.dispatch({
                actionType: ActionConstants.CUSTOM_LOGIN_SET_USERINFO,
                value: userInfo
            });
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/CustomLoginActions.tsx